<template>
  <div ref="mainContainer" v-scrollbar="{ id: 'list-layout-scroll', onScrollEnd: () => $emit('scroll-end') }" class="list-layout-container" :class="{ stretch: isStretchContent }">
    <cs-scrollbar-vertical
      id="scroll-content"
      class="list-layout-scroll"
    />
    <div class="layout-content">
      <substrate-mount ref="list" flat>
        <slot />
      </substrate-mount>
    </div>
  </div>
</template>

<script>
import { isIOS } from 'mobile-device-detect';

import SubstrateMount from '@/components/capusta/SubstrateMount';

export default {
  components: {
    SubstrateMount,
  },
  mounted() {
    if (this.$validate.isUndefined(this.$refs.list)) {
      return;
    }

    const documentHeight = document.documentElement.clientHeight;
    const listContainerHeight = this.$refs.list.$el.clientHeight;

    this.isStretchContent = documentHeight < listContainerHeight;
  },
  data() {
    return {
      isIOS,
      isStretchContent: false,
    };
  },
  methods: {
    scrollHandler() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0;
      let offset = scrollTop + window.innerHeight;
      let height = document.documentElement.offsetHeight;

      // load and push transactions when reaches bottom
      let heightFactor = 100;
      if (offset + heightFactor >= height) {
        // this.loadNextPage();
        this.$emit('load-next');
      }

      // filters block
      let arrangerRect = this.$refs.mainContainer.getBoundingClientRect();
      let arrangerOffset = arrangerRect.top;

      this.SET_SCROLL_STATES({
        type: 'Partnership_block_is_fixed',
        params: arrangerOffset <= 5,
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .list-layout-container
    width: 100%
    position: relative
    align-self: flex-end
    overflow-x: hidden
    overflow-y: auto
    box-sizing: border-box
    -webkit-overflow-scrolling: touch

    +respond-to('small')
      width: 500px
      margin: 0 auto
      align-self: center
      border-radius: 10px

    &.stretch
      align-self: stretch

  .list-layout-scroll
    display: none
</style>
